



































































































































import { computed, defineComponent, onMounted, ref, toRefs, PropType, watch, nextTick } from '@vue/composition-api';
import { AdgroupConfig, AdgroupFormData, AD_GROUP_WEBSITE_TYPES, CampaignFormData, CreateMode } from '@tt4b/ttam-enums';
import PromotionPixel from './index';
import PixelListSelectInfiniteScroll from '@/components/common/pixel-list-select/pixel-list-select-infinite-scroll.vue';
import {
  useAdgroupPromotionValidate,
  useAllowlist,
  useStdObjectiveType,
  useStore,
  useStdAdgroupOptimizationGoal,
} from '@tt4b/ttam-hooks';
import { trackEvent } from './../../../utils/index';

const name = 'ttam-promotion-pixel-compose';
export default defineComponent({
  name,
  components: {
    TtamPromotionPixelList: PromotionPixel.TtamPromotionPixelList,
    TtamPromotionPixelIosTips: PromotionPixel.TtamPromotionPixelIosTips,
    TtamPromotionPixelConversionTips: PromotionPixel.TtamPromotionPixelConversionTips,
    TtamPromotionPixelWebsiteType: PromotionPixel.TtamPromotionPixelWebsiteType,
    TtamPromotionPixelMidFunnelTips: PromotionPixel.TtamPromotionPixelMidFunnelTips,
    TtamPromotionPixelEventInactiveTips: PromotionPixel.TtamPromotionPixelEventInactiveTips,
    TtamPromotionPixelNativeTips: PromotionPixel.TtamPromotionPixelNativeTips,
    PixelListSelectInfiniteScroll,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
    },
    isBrandTrack: {
      type: Boolean,
      default: false,
    },
    // config
    showSwitchObjectiveTip: {
      type: Boolean,
      default: false,
    },
    checkExistingData: {
      type: Boolean,
      default: false,
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    copyNum: {
      type: Number,
      default: 0,
    },
    // 错误字段map，初始化后的报错信息
    errorsMap: {
      type: Object as PropType<Record<string, string>>,
      default: () => ({}),
    },
  },
  // eslint-disable-next-line max-lines-per-function
  setup(props, { emit }) {
    const pixelFormItem = ref(null);
    const externalActionFormItem = ref(null);
    const { campaignData, adgroupData, adgroupConfig, checkExistingData, createMode, copyNum } = toRefs(props);
    const { disablePixel, disablePixelTypeRadio } = toRefs(adgroupConfig.value);
    const { state } = useStore();
    const aadvid = computed(() => state.baseInfo.value.aadvid);
    const { isHideOptimizationEventWhite } = useAllowlist();
    const { isTraffic, isBrandAuction } = useStdObjectiveType({ campaignFormData: campaignData });
    const isHideOptimizationEvent = computed(() => isTraffic.value && isHideOptimizationEventWhite.value);

    const adRefPixel = computed({
      get: () => adgroupData.value.adRefPixelId,
      set: (val: string) => {
        emit('pixel-change', val);
        setTimeout(() => pixelFormItem.value?.validate('adRefPixelId'), 0);
      },
    });

    const isNoSelectPixelOptimizationGoal = computed(() => {
      const { isOptGoalLandingPageView } = useStdAdgroupOptimizationGoal({ adgroupFormData: adgroupData });
      return isOptGoalLandingPageView.value;
    });

    const externalAction = computed({
      get: () => {
        // 没选Pixel，不回显Optimization event
        if (isNoSelectPixelOptimizationGoal.value) {
          return 0;
        }
        return adgroupData.value.externalAction;
      },
      set: (val: number) => {
        emit('pixel-event-change', val);
        setTimeout(() => externalActionFormItem.value?.validate('externalAction'), 0);
      },
    });
    const websiteType = computed({
      get: () => adgroupData.value.promotionWebsiteType,
      set: (val: number) => {
        emit('pixel-website-type-change', val);

        nextTick(() => {
          trackEvent('ad_group_promotion_pixel_type_change', {
            objective_type: campaignData.value?.objectiveType,
            pixel_type: val,
          });
        });
      },
    });

    const isWebsitePage = computed(() => websiteType.value === AD_GROUP_WEBSITE_TYPES.offSite);

    // 初始化 pixel list
    const toPixel = PromotionPixel.useCommonPixelUrl({ aadvid: aadvid.value });
    const {
      run: getPixel,
      data: pixelData,
      originalData: originalPixelData,
      isLoading: pixelLoading,
      isEmpty: pixelEmpty,
    } = PromotionPixel.usePixelListDataSource({
      campaignData,
      adgroupData,
      createMode,
    });
    const curPixel = computed(() => originalPixelData.value.find(i => i.id === adRefPixel.value));
    const curPixelCode = computed(() => curPixel.value?.pixelCode ?? '');
    const pixelEventUrl = computed(() =>
      PromotionPixel.useCommonPixelEventUrl({
        pixelCode: curPixel.value?.pixelCode,
        aadvid: aadvid.value,
      }),
    );

    // 初始化 pixel event
    const toPixelEvent = computed(() =>
      PromotionPixel.useCommonPixelEventUrl({ aadvid: aadvid.value, pixelCode: curPixelCode.value }),
    );
    const {
      run: getPixelEvent,
      data: pixelEventData,
      isLoading: pixelEventLoading,
      isEmpty: pixelEventEmpty,
      originData: pixelEventList,
    } = PromotionPixel.usePixelEventListDataSource({
      adgroupData,
      campaignData,
      pixelCode: curPixelCode,
      createMode,
    });

    // checkbox 逻辑
    const { pixelIsEnableVisible } = PromotionPixel.usePixelIsEnableVisible({ campaignData, adgroupData });

    // ios tips 逻辑
    const { visible: pixelIosTipsVisible } = PromotionPixel.usePixelIosTipsVisible({
      adgroupData,
      pixelList: originalPixelData,
    });

    // mid-funnel tips 逻辑
    const { visible: pixelMidFunnelTipsVisible } = PromotionPixel.usePixelMidFunnelTipsVisible({
      adgroupData,
    });

    // native tips 逻辑
    const { visible: pixelNativeTipsVisible } = PromotionPixel.usePixelNativeTipsVisible({
      adgroupData,
      campaignData,
    });

    // event-inactive tips 逻辑
    const { visible: pixelEventInactiveTipsVisible } = PromotionPixel.usePixelEventInActiveTipsVisible({
      adgroupData,
      pixelEventList,
    });

    // conversion tips 逻辑
    const isShowSwitchConversionTip = computed(() => props.showSwitchObjectiveTip && isHideOptimizationEvent.value);

    // 初始化 website type
    const { onSiteConfig, offSiteConfig } = PromotionPixel.usePixelWebsiteTypeConfigs();
    const { visible: pixelWebsiteTypeVisible } = PromotionPixel.usePixelWebsiteTypePropsVisible({ campaignData });

    // pxiel show/hide
    const radioAndIsWebsitePage = computed(() => pixelWebsiteTypeVisible.value && isWebsitePage.value);
    const noneCheckboxRadio = computed(() => !pixelIsEnableVisible.value && !pixelWebsiteTypeVisible.value);
    const isShowPixel = computed(
      () => pixelIsEnableVisible.value || noneCheckboxRadio.value || radioAndIsWebsitePage.value,
    );
    const isShowInstantPageEvent = computed(() => pixelWebsiteTypeVisible.value && !isWebsitePage.value);
    const isShowPixelEventList = computed(
      () =>
        !(isBrandAuction.value || (isHideOptimizationEvent.value && (!checkExistingData.value || isWebsitePage.value))),
    );

    // rules
    const { adRefPixelIdValidator, externalActionValidator } = useAdgroupPromotionValidate();

    const { selectedPixel } = PromotionPixel.usePropsSelectedPixel();

    const { checkIsPixelDisabled } = PromotionPixel.useCheckIsPixelDisabled({
      adgroupData,
      createMode,
      copyNum,
    });

    onMounted(() => {
      getPixel();
    });

    const onPixelRefresh = () => {
      trackEvent('create_adgroup_ad_detail_pixel_refresh');
      getPixel();
    };

    const onPixelCreate = () => {
      trackEvent('create_adgroup_ad_detail_pixel_create');
    };

    const onPixelNameClick = () => {
      trackEvent('create_adgroup_ad_detail_conversion');
    };

    const onPixelEventNameClick = () => {
      trackEvent('create_adgroup_ad_detail_pixel_create');
    };

    const onPixelEventCreate = () => {
      trackEvent('create_adgroup_ad_detail_pixel_event_create');
    };

    const onPixelEventOpen = () => {
      trackEvent('module_ad_group_optimization_event_dropdown_click');
    };

    const onPixelEventRefresh = () => {
      trackEvent('create_adgroup_ad_detail_pixel_event_refresh');
      getPixelEvent();
    };

    const onLinkClick = () => {
      trackEvent('create_adgroup_conversions_obj_recommend');
      emit('conversion-tips-click');
    };

    return {
      name,
      toPixel,
      curPixel,
      pixelData,
      adRefPixel,
      pixelEmpty,
      isShowPixel,
      websiteType,
      disablePixel,
      disablePixelTypeRadio,
      pixelLoading,
      toPixelEvent,
      onSiteConfig,
      offSiteConfig,
      isWebsitePage,
      pixelEventUrl,
      pixelEventData,
      externalAction,
      pixelEventEmpty,
      originalPixelData,
      pixelEventLoading,
      pixelIsEnableVisible,
      isShowPixelEventList,
      pixelIosTipsVisible,
      pixelMidFunnelTipsVisible,
      pixelEventInactiveTipsVisible,
      isShowInstantPageEvent,
      pixelWebsiteTypeVisible,
      isShowSwitchConversionTip,
      pixelNativeTipsVisible,
      adRefPixelIdValidator,
      externalActionValidator,
      pixelFormItem,
      externalActionFormItem,
      selectedPixel,
      onLinkClick,
      getPixelEvent,
      onPixelRefresh,
      onPixelCreate,
      onPixelNameClick,
      onPixelEventRefresh,
      onPixelEventNameClick,
      onPixelEventCreate,
      checkIsPixelDisabled,
      onPixelEventOpen,
    };
  },
});
